<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1>Accueil Easy Grader</h1>
    </div>

        <div class="card-deck mb-3 text-center">
      <div class="card mb-4 shadow-sm w-50">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Leads</h4>
        </div>
        <div class="card-body">
          <p class=" mt-3 mb-4">
            {{leads.length}} leads
          </p>
          <router-link tag="button" class="btn btn-lg btn-block btn-primary" :to="({ name: 'Admin Leads'})">Voir les leads</router-link>
        </div>
      </div>

      <div class="card mb-4 shadow-sm w-50">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Survey</h4>
        </div>
        <div class="card-body">
          <p class=" mt-3 mb-4">
            {{quizes.length}} sections <br />
            {{questionCount}} questions
          </p>
          <router-link tag="button" class="btn btn-lg btn-block btn-primary" :to="({ name: 'Admin Survey'})">Éditer le grader</router-link>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

  import { mapGetters, mapActions, mapMutations } from 'vuex';
  export default {

    name: 'admin_home',

    computed: {
      ...mapGetters({
        quizes: 'quiz/list',
        leads: 'lead/list'
      }),

      questionCount: function () {
      return this.quizes.reduce((acc,element) => acc + element.questions.length, 0);
    }
    },

  }
</script>





// WEBPACK FOOTER //
// src/pages/admin/AdminHomePage.vue